export default __webpack_public_path__ + "static/media/cargo.cb2ae1d3.png";